import { render } from "./IntermediateScreen.vue?vue&type=template&id=aefad4da&scoped=true"
import script from "./IntermediateScreen.vue?vue&type=script&lang=js"
export * from "./IntermediateScreen.vue?vue&type=script&lang=js"

import "./IntermediateScreen.vue?vue&type=style&index=0&id=aefad4da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aefad4da"]])

export default __exports__